import React, { useState } from 'react';
import {getPreCustomerByMsisdn, getPreCustomerByMsisdnAndEmail, setEmailAddress, setOtpLoading, setPhoneNo, setShowForm} from "../redux/features/oxygen/oxygenRetailSlice";
import { useDispatch, useSelector } from 'react-redux';
import useCustomAlert from './Alert2';
import { handleContinueOnboarding } from './CustomerRedirect';
import { useNavigate } from 'react-router-dom';
import { hideModal } from '../redux/features/oxygen/customModalSlice';
import { updatePrecustomer } from '../redux/features/precustomers/PrecustomerSlice';

const OxyConfirmMsisdnEmailModal = ({data}) => {
    const { msisdn, email, parterId, } = data;
    const isLoading = useSelector((state) => state.oxygenRetail?.otpLoading);
    const dispatch = useDispatch();
    const customAlert = useCustomAlert();
    const navigate = useNavigate();

    const handleProceed = async () => {
        dispatch(setOtpLoading(true));
    
        const payload = {
            msisdn,
            email,
            partnerId: parterId
        };
    
        try {
          // const actionResult = await dispatch(getPreCustomerByMsisdnAndEmail(payload));
          const actionResult = await dispatch(getPreCustomerByMsisdn(msisdn));
  
          if (getPreCustomerByMsisdnAndEmail.fulfilled.match(actionResult) ||  actionResult?.payload?.status === true) {
              const res = actionResult.payload || actionResult; // Get response payload
  
              if (res?.status === true || res?.payload?.status === true) {
                  const partnerIdReturned = res?.partnerId || res?.payload?.partnerId;
                  const data = res?.payload?.data || res?.data;
  
                  if (partnerIdReturned && Number(partnerIdReturned) !== Number(parterId)) {
                      dispatch(setOtpLoading(false));
                      customAlert.showToast("error", "You are not an Oxygen Customer, Please go through the FBN onboarding Route to continue");
                      dispatch(hideModal());
                      return;
                  }
  
                  if (data?.onboardingStatus) {
                      if (data.onboardingStatus === "NEWENTRY") {
                          dispatch(setOtpLoading(false));
                          dispatch(setPhoneNo(msisdn));
                          dispatch(setEmailAddress(email));
                          dispatch(setShowForm(true));
                          dispatch(hideModal());
                      } else {
                          dispatch(setOtpLoading(false));
                          handleContinueOnboarding(data, dispatch, navigate, "oxygen");
                          dispatch(hideModal());
                      }
                  } else {
                      dispatch(setOtpLoading(false));
                      dispatch(setPhoneNo(msisdn));
                      dispatch(setEmailAddress(email));
                      dispatch(updatePrecustomer({
                          precustomer: {
                          msisdn: msisdn,
                          email: email,
                        }
                      }));
                      // dispatch(setShowForm(true));
                      dispatch(hideModal());
                      navigate("/oxygen-devices");
                  }
              } else {
                  dispatch(setOtpLoading(false));
                  customAlert.showToast("error", res?.message || res?.payload?.message || "Failed to get PreCustomer Details");
                  dispatch(hideModal());
              }
          } else {
            customAlert.showToast("error", actionResult.error?.message || "Failed to fetch PreCustomer details");
            throw new Error(actionResult.error?.message || "Failed to fetch PreCustomer details");
          }
        } catch (error) {
            dispatch(setOtpLoading(false));
            customAlert.showToast("error", error.message || "An unexpected error occurred.");
            dispatch(hideModal());
        }
    };
    

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="mb-0 card-title text-info">
          Customer Details
        </h3>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-12 mb-4">
            <div className="d-flex flex-column align-items-start my-2">
              <div className='mb-2' style={{ fontSize: "18px", color: "black" }}>
                Kindly Confirm that your details below are correct
              </div>
              <div style={{padding: "20px 0 "}}>
                <p style={{ fontSize: "18px", color: "black" }}>Phone Number: {msisdn} </p>
                <p style={{ fontSize: "18px", color: "black" }}>Email: {email} </p>
              </div>
            </div>
          </div>

        <div className="col-md-6">
            <div className="form-group d-flex justify-content-between">
                <button className="btn btn-secondary" onClick={() => dispatch(hideModal())}>
                    <b>Cancel</b>
                </button>
                <button className="btn btn-primary" onClick={handleProceed}>
                    <b>{isLoading ? "Loading..." : "Proceed"}</b>
                </button>
            </div>
        </div>

        </div>
      </div>
    </div>
  )
}

export default OxyConfirmMsisdnEmailModal